"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !exports.hasOwnProperty(p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createUseSink = exports.createSinking = exports.useSink = exports.sinking = void 0;
const redux_sink_1 = require("redux-sink");
const createSinking_1 = require("./createSinking");
const createUseSink_1 = require("./createUseSink");
/**
 * connect sinks with component, only connect state, reducers and effects
 * @param sinks array args of sink classes
 */
exports.sinking = createSinking_1.createSinking(redux_sink_1.SinkFactory);
/**
 * connect sink with using hook
 * @param sink sink class
 */
exports.useSink = createUseSink_1.createUseSink(redux_sink_1.SinkFactory);
/**
 * create sinking connector use SinkContainer
 */
exports.createSinking = createSinking_1.createSinking;
/**
 * create useSink hook use SinkContainer
 */
exports.createUseSink = createUseSink_1.createUseSink;
__exportStar(require("redux-sink"), exports);
